import routes from './userRoutes';
import UserComponent from "./userComponent";
import UserListComponent from "./list/userListComponent";
import UserService from './services/userService';
import UserInviteComponent from "./list/invite/userInviteComponent";
import UserProfileComponent from "./list/profile/userProfileComponent";
import MyProfileComponent from "./myProfile/myProfileComponent";

const UserModule = angular.module('app.user', [
])
    .config(routes)
    .component('user', UserComponent)
    .component('myProfile', MyProfileComponent)
    .component('userList', UserListComponent)
    .component('userInvite', UserInviteComponent)
    .component('userProfile', UserProfileComponent)
    .service('UserService', UserService);

export default UserModule;



// WEBPACK FOOTER //
// ./src/app/pages/user/index.js